import { useState } from 'react';

import { useCheckoutSession } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useCheckoutSession';
import { ProcessingStrategy } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/ProcessingStrategy';
import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

interface ProcessingStrategyChooseButtonProps {
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity;
}

export const ProcessingStrategyChooseButton = ({ paymentMethodDetailEntity }: ProcessingStrategyChooseButtonProps) => {
  const { refreshCheckoutSessionAndPaymentMethodEntities } = useCheckoutSession();
  const { sm } = useScreen();

  const [open, setOpen] = useState(false);

  const handleOpen = (opened: boolean) => {
    if (opened === false) {
      refreshCheckoutSessionAndPaymentMethodEntities();
    }
    setOpen(opened);
  };

  const onClick = () => {
    setOpen(true);
  };

  return (
    <>
      <StandardButton main size="small" style={{ minWidth: 0 }} onClick={onClick}>
        <Text tId={'SELECT'} />
      </StandardButton>
      <NemuruDialog
        opened={open}
        setOpened={handleOpen}
        titleTextElement={<Text tId={sm ? 'PROCESSING_STRATEGY' : 'PROCESSING_STRATEGY_MOBILE'} />}
        dialogProps={{ maxWidth: false }}
        paperProps={{ maxWidth: 880 }}
      >
        <ProcessingStrategy
          paymentMethodDetailEntity={paymentMethodDetailEntity}
          options={{ showStatusMessage: true }}
        />
      </NemuruDialog>
    </>
  );
};
